<script>
import ResizeObserver from 'resize-observer-polyfill'

export default {
  props: {
    flexColumnsWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      resizeObserver: null,
      flexColumnsPerRow: 0,
    }
  },
  watch: {
    flexColumnsWidth() {
      this.createResizeObserver()
    },
  },
  mounted() {
    this.createResizeObserver()
    if (this.flexColumnsWidth) {
      this.createResizeObserver()
    }
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.tabContentContainer)
    }
  },
  methods: {
    createResizeObserver() {
      if (!this.resizeObserver && this.flexColumnsWidth) {
        this.resizeObserver = new ResizeObserver(this.handleResize)
        this.resizeObserver.observe(this.$refs.tabContentContainer)
      }
    },
    handleResize(entries) {
      const entry = entries[0]
      const { width } = entry.contentRect
      this.flexColumnsPerRow = Math.floor(width / this.flexColumnsWidth)
    },
  },
}
</script>

<template>
  <div ref="tabContentContainer" :class="$style.tabContentContainer">
    <slot :flex-columns-per-row="flexColumnsPerRow" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.tabContentContainer {
  position: relative;
  padding: 25px;
  margin-top: 10px;
  background-color: $white;
  border: 2px solid $light-gray;
  border-radius: 8px;
  box-shadow: 3px 3px 6px rgba(196, 196, 196, 0.3);
}
</style>
